import {ScheduleDataModel} from '../types';
import {query} from '@di-nxt/query';
import {isDateInPeriod} from './isDateInPeriod';

export const getTeamMemberWorkload = (
  membershipId: number,
  date: Date | string,
  viewmodel: ScheduleDataModel,
): number => {
  const totalMonthlyTaskHours = query(viewmodel.shiftsWithTasks)
    .where(
      st =>
        st.shift.membershipId === membershipId &&
        isDateInPeriod(st.shift.distrDate, date, 'month'),
    )
    .sum(st => st.totalTasksHours);

  return totalMonthlyTaskHours;
};
